import {
  Bot,
  Link,
  Building2,
  Camera,
  BarChart3,
  Coins,
  CreditCard,
  Database,
  DollarSign,
  Droplet,
  Gamepad2,
  Globe,
  Landmark,
  Layers,
  MessageSquare,
  Palette,
  Percent,
  Phone,
  Rocket,
  Settings,
  Shield,
  Smartphone,
  Star,
  TrendingUp,
  Users,
  Vault,
  Wallet,
  Zap,
} from "lucide-react";
import { LucideIcon } from "lucide-react";

// Category to icon mapping
const categoryIconMap: Record<string, LucideIcon> = {
  // Main categories
  DeFi: Coins,
  AI: Bot,
  AMM: TrendingUp,
  Analytics: BarChart3,
  Bridge: Link,
  DeFAI: Zap,
  Defi: Coins, // Alternative spelling
  Ecosystem: Globe,
  HLP: Star,
  Infra: Database,
  Infrastructure: Database,
  Launchpad: Rocket,
  Lending: Landmark,
  LST: Droplet,
  "Mobile App": Smartphone,
  NFT: Palette,
  Options: Settings,
  Privacy: Shield,
  SocialFi: Users,
  Stablecoin: DollarSign,
  "TG Bot": MessageSquare,
  Trading: TrendingUp,
  Vault: Vault,

  // Compound categories (these will match when a category contains multiple comma-separated values)
  "Delta Neutral Strategy": Percent,
  Yield: TrendingUp,
  Points: Star,

  // Default fallback icon
  Other: Settings,
};

/**
 * Get the appropriate Lucide icon component for a given category
 * @param category - The category name (can be comma-separated)
 * @returns LucideIcon component
 */
export const getCategoryIcon = (category: string): LucideIcon => {
  // Handle comma-separated categories by taking the first one
  const primaryCategory = category.split(",")[0].trim();

  // Try exact match first
  if (categoryIconMap[primaryCategory]) {
    return categoryIconMap[primaryCategory];
  }

  // Try partial matches for compound categories
  const categoryLower = primaryCategory.toLowerCase();

  if (categoryLower.includes("defi")) return Coins;
  if (categoryLower.includes("ai")) return Bot;
  if (categoryLower.includes("amm")) return TrendingUp;
  if (categoryLower.includes("bridge")) return Link;
  if (categoryLower.includes("lending")) return Landmark;
  if (categoryLower.includes("nft")) return Palette;
  if (categoryLower.includes("mobile")) return Smartphone;
  if (categoryLower.includes("bot")) return MessageSquare;
  if (categoryLower.includes("trading")) return TrendingUp;
  if (categoryLower.includes("stablecoin")) return DollarSign;
  if (categoryLower.includes("vault")) return Vault;
  if (categoryLower.includes("analytics")) return BarChart3;
  if (categoryLower.includes("social")) return Users;
  if (categoryLower.includes("infra")) return Database;
  if (categoryLower.includes("launchpad")) return Rocket;

  // Default fallback
  return Settings;
};

/**
 * Get all available category icons for reference
 * @returns Record of category names to icon components
 */
export const getAllCategoryIcons = (): Record<string, LucideIcon> => {
  return { ...categoryIconMap };
};
